module.exports = __webpack_public_path__ + "img/hanshinc.25748232.svg";